import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full bg-gray-900 text-white py-8 full-viewport-width">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img src="/Logo.png" alt="Enpact Logo" className="h-8 w-auto" />
              <h3 className="text-xl font-bold text-enpact-red">Enpact</h3>
            </div>
            <p className="text-gray-300 text-sm">
              Advanced Monthly Revenue Stream Calculator for Annuity Policies
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-200">Contact Information</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p>14th Floor, Metropolitan Plaza Building</p>
              <p>1-11-1 Nishi-Ikebukuro, Toshima-ku</p>
              <p>Tokyo 171-0021, Japan</p>
              <p>Email: liuyan@enpact.jp</p>
              <p>TEL: 03-6778-7713</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-200">Quick Links</h4>
            <div className="space-y-2 text-sm">
              <a href="/" className="text-gray-300 hover:text-enpact-red transition-colors duration-200 block">
                Home
              </a>
              <a href="/dashboard" className="text-gray-300 hover:text-enpact-red transition-colors duration-200 block">
                Dashboard
              </a>
              <a href="#" className="text-gray-300 hover:text-enpact-red transition-colors duration-200 block">
                About Us
              </a>
              <a href="#" className="text-gray-300 hover:text-enpact-red transition-colors duration-200 block">
                Contact
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © 2024 Enpact. All rights reserved. | Revenue Stream Calculator for Annuity Policies
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
